import React from "react";

const Messages = () => {
  return (
    <div className="text-center my-6">
      <h1 className="text-base-100 header-responsive ">
        Welcome to <span className="text-product">IWeather</span>
      </h1>
      <p className="text-base-200 text-responsive">
        Choose a location to see the weather forecast
      </p>
    </div>
  );
};

export default Messages;
